import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * 메시지 내용에서 @멘션을 파란색 뱃지로 렌더링합니다.
 * 예: "안녕하세요 @홍길동 님" → "안녕하세요 " + [파란색@홍길동] + " 님"
 *
 * @param {string} content - 메시지 내용
 * @param {boolean} isMe - 내 메시지 여부 (색상 반전용)
 * @returns {JSX.Element}
 */
export const renderMessageWithMentions = (content, isMe = false) => {
  if (!content) return null;

  // @이름 패턴 파싱
  const parts = content.split(/(@[^\s@]+)/g);

  if (parts.length <= 1) {
    // 멘션 없는 일반 메시지
    return (
      <Typography sx={{ whiteSpace: 'pre-line', wordBreak: 'break-word' }}>
        {content}
      </Typography>
    );
  }

  return (
    <Typography
      component="span"
      sx={{ whiteSpace: 'pre-line', wordBreak: 'break-word', display: 'block' }}
    >
      {parts.map((part, index) => {
        if (part.startsWith('@')) {
          return (
            <Box
              key={index}
              component="span"
              sx={{
                display: 'inline',
                backgroundColor: isMe ? 'rgba(255,255,255,0.25)' : 'rgba(25, 118, 210, 0.12)',
                color: isMe ? '#ffffff' : '#1565c0',
                fontWeight: 'bold',
                borderRadius: '4px',
                px: 0.5,
                py: 0.1,
                fontSize: '0.875rem',
                cursor: 'default',
              }}
            >
              {part}
            </Box>
          );
        }
        return <React.Fragment key={index}>{part}</React.Fragment>;
      })}
    </Typography>
  );
};

/**
 * 메시지에 나를 멘션했는지 확인
 * @param {string} content - 메시지 내용
 * @param {string} myName - 내 이름
 * @param {string} mentions - 멘션된 uuid 목록 (콤마 구분)
 * @param {string} myUuid - 내 UUID
 * @returns {boolean}
 */
export const isMentionedMe = (content, myName, mentions, myUuid) => {
  if (mentions && myUuid) {
    return mentions.split(',').map(u => u.trim()).includes(myUuid);
  }
  if (content && myName) {
    return content.includes(`@${myName}`);
  }
  return false;
};
